module.exports = __webpack_public_path__ + "static/media/car-drive.f1df0bf8.jpg";